import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import WebsiteLayout from "@/components/layout/WebsiteLayout";
import Layout from "@/components/layout/Layout";
import Index from "@/pages/Index";
import Features from "@/pages/Features";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Calendar from "@/pages/Calendar";
import CreateEvent from "@/pages/CreateEvent";
import FriendsAndFamily from "@/pages/FriendsAndFamily";
import Notifications from "@/pages/Notifications";
import { AuthProvider } from "@/app/hooks/useAuth";
import CalendarSync from "@/pages/CalendarSync";
import { useAuth } from "@/app/hooks/useAuth";

// Protected route component that redirects to login if not authenticated
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes with WebsiteLayout */}
      <Route path="/" element={<WebsiteLayout />}>
        <Route index element={<Index />} />
        <Route path="features" element={<Features />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
      </Route>
      
      {/* Protected routes with Layout (includes Sidebar) */}
      <Route path="/" element={<Layout />}>
        <Route path="dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="calendar" element={
          <ProtectedRoute>
            <Calendar />
          </ProtectedRoute>
        } />
        <Route path="create-event" element={
          <ProtectedRoute>
            <CreateEvent />
          </ProtectedRoute>
        } />
        <Route path="create-event/:group" element={
          <ProtectedRoute>
            <CreateEvent />
          </ProtectedRoute>
        } />
        <Route path="friends-and-family" element={
          <ProtectedRoute>
            <FriendsAndFamily />
          </ProtectedRoute>
        } />
        <Route path="notifications" element={
          <ProtectedRoute>
            <Notifications />
          </ProtectedRoute>
        } />
        <Route path="calendar-sync" element={
          <ProtectedRoute>
            <CalendarSync />
          </ProtectedRoute>
        } />
        {/* Add routes for the sidebar navigation items */}
        <Route path="friends" element={
          <ProtectedRoute>
            <FriendsAndFamily initialTab="friends" />
          </ProtectedRoute>
        } />
        <Route path="family" element={
          <ProtectedRoute>
            <FriendsAndFamily initialTab="family" />
          </ProtectedRoute>
        } />
        <Route path="hobby" element={
          <ProtectedRoute>
            <Calendar initialGroup="hobby" />
          </ProtectedRoute>
        } />
        <Route path="holidays" element={
          <ProtectedRoute>
            <Calendar initialGroup="holidays" />
          </ProtectedRoute>
        } />
        <Route path="profile" element={
          <ProtectedRoute>
            <div>Profile Page</div>
          </ProtectedRoute>
        } />
        <Route path="settings" element={
          <ProtectedRoute>
            <div>Settings Page</div>
          </ProtectedRoute>
        } />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="fyndtyme-theme">
      <Router>
        <AuthProvider>
          <AppRoutes />
          <Toaster />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
